import reducers from './reducers';
import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
  reducer: reducers,
});

export { store };

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
